// Scoped markdown styling. `.root` is hashed by CSS Modules; the descendant
// element selectors are local to it, so they only touch react-markdown's
// output. Tuned for chat-sized copy (the agent panel answer).
.root {
  color: var(--color-foreground);
  font-size: 13px;
  line-height: 1.55;
  word-break: break-word;

  // Collapse the outer margins so the block sits flush in its container.
  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  p {
    margin: 0 0 8px;
  }

  ul,
  ol {
    margin: 0 0 8px;
    padding-left: 20px;
  }

  li {
    margin: 2px 0;
  }

  li > p {
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: 600;
    line-height: 1.3;
    margin: 12px 0 6px;
  }

  h1 {
    font-size: 17px;
  }

  h2 {
    font-size: 15px;
  }

  h3,
  h4 {
    font-size: 14px;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  a {
    color: var(--color-primary);
    text-decoration: underline;
  }

  code {
    background: var(--color-secondary);
    border-radius: 4px;
    font-family: var(--font-mono, ui-monospace, monospace);
    font-size: 0.92em;
    padding: 1px 4px;
  }

  pre {
    background: var(--color-secondary);
    border-radius: 6px;
    margin: 0 0 8px;
    overflow-x: auto;
    padding: 10px 12px;

    code {
      background: none;
      padding: 0;
    }
  }

  blockquote {
    border-left: 3px solid var(--color-border);
    color: var(--color-muted);
    margin: 0 0 8px;
    padding: 2px 0 2px 12px;
  }

  hr {
    border: none;
    border-top: 1px solid var(--color-border);
    margin: 12px 0;
  }

  table {
    border-collapse: collapse;
    display: block;
    margin: 0 0 8px;
    overflow-x: auto;
    width: 100%;
  }

  th,
  td {
    border: 1px solid var(--color-border);
    padding: 5px 8px;
    text-align: left;
  }

  th {
    background: var(--color-secondary);
    font-weight: 600;
  }
}
